import * as React from "react";
import {cx} from "emotion";

import "./image-gallery-panel.scss";

import {cs}                 from "../../react/chain-services";
import {fragments}          from "../../react/fragments";
import {GlobalEvent}        from "../../react/global-event";
import {keyCombo}           from "../../react/key-combo";
import {keyed, keyed1}      from "../../react/keyed";
import {UseState}           from "../../react/use-state";
import {chain}              from "../../utils/fs";
import {GlobalKeyDown2}     from "../browser/global-key-down-2";
import {LoadImgSize}        from "../browser/load-img-size";
import {ObserveMousePos}    from "../browser/observe-mouse-pos";
import {ObserveWindowSize2} from "../browser/observe-window-size-2";
import {getContainRatio}    from "../image-editor/common/get-contain-ratio";
import {multiplySize}       from "../image-editor/common/multiply-size";
import {multiplyVector}     from "../image-editor/common/multiply-vector";
import {subtractVector}     from "../image-editor/common/subtract-vector";

export const ImageGalleryPanel = ({imgs, hideThumbnails, maxWidth}) => cs(
    ["ws", (_, next) => ObserveWindowSize2({next})],
    ["imgIndex", (_, next) => UseState({initValue: 0, next})],
    ["img", ({imgIndex}, next) => next(imgs.value[imgIndex.value % imgs.value.length])],

    ({imgIndex, img}, next) => (
        <div className="image-gallery-panel-19w">
            {next()}

            {!hideThumbnails && (
                <div className="bottom" onClick={(e) => e.stopPropagation()}>
                    {imgs.value.map((img1, i) => cs(
                        keyed(img1.thumbnail ?? img1.enlarged),
                        () => (
                            <div
                                className={cx("thumb", {selected: img1 === img})}
                                onClick={() => imgIndex.onChange(i)}
                            >
                                <img {...{
                                    src: img1.thumbnail ?? img1.enlarged,

                                    "xd-qa-type": "image",
                                    "xd-qa-name": "Preview image thumbnail #" + (i + 1),
                                }}/>
                            </div>
                        ),
                    ))}
                </div>
            )}

            {GlobalKeyDown2({
                check: keyCombo("ArrowLeft"),
                action: () => imgIndex.onChange((imgIndex.value - 1 + imgs.value.length) % imgs.value.length),
            })}
            {GlobalKeyDown2({
                check: keyCombo("ArrowRight"),
                action: () => imgIndex.onChange((imgIndex.value + 1) % imgs.value.length),
            })}
        </div>
    ),


    ["mousePos", ({ws}, next) => ObserveMousePos({
        next: (mousePos) => next(mousePos ?? {x:ws.width/2, y: ws.height/2}),
    })],

    ["url", ({img}, next) => next(img.enlarged ?? img.thumbnail)],
    ({url}, next) => keyed1({key: url, next}),
    ["imgSize", (_, next) => LoadImgSize({next})],
    ["frameRectGross", ({ws}, next) => {
        const width = chain(
            ws.width - 40,
            (_) => maxWidth ? Math.min(maxWidth, _) : _,
        );
        return next({
            x: (ws.width - width) / 2, y: 20,
            width: width,
            height: ws.height - 40 - 80,
        });
    }],
    ["frameSize", ({imgSize, frameRectGross}, next) => next(imgSize.value && (
        multiplySize(
            imgSize.value,
            getContainRatio(
                frameRectGross,
                imgSize.value
            ),
        )
    ))],
    ["zoom", (_, next) => UseState({initValue: 1, next})],
    ({zoom}, next) => fragments(
        next(),
        GlobalEvent({
            eventName: "wheel",
            action: (e) => {
                e.preventDefault();
                zoom.onChange(chain(
                    zoom.value * (e.deltaY > 0 ? 1.1 : 1/1.1),
                    (_) => Math.max(1, _),
                    (_) => Math.min(4, _),
                ));
            },
        })
    ),
    ["zoomedFrameSize", ({zoom, frameSize}, next) => next(frameSize && multiplySize(frameSize, zoom.value))],

    ["zoomedFramePos", ({mousePos, frameRectGross, frameSize, zoom}, next) => next(frameSize && chain(
        {
            x: frameRectGross.x + frameRectGross.width  /2 - frameSize.width  /2,
            y: frameRectGross.y + frameRectGross.height /2 - frameSize.height /2,
        },
        (_) => subtractVector(mousePos, _),
        (_) => multiplyVector(_, zoom.value),
    ))],
    ({imgSize}, next) => <>
        <div {...{
            className: "img",
            onClick: (e) => e.stopPropagation(),
        }}>
            {next()}
        </div>

        {(imgs.loading || !imgSize.value) && (
            <div {...{
                className: "loading",
                onClick: (e) => e.stopPropagation(),
            }}>
                <i className="fa fa-spinner fa-pulse"/>

                <div className="message">
                    Applying Personalization...
                </div>
            </div>
        )}
    </>,
    ({url, imgSize, zoomedFrameSize, frameRectGross, zoom, zoomedFramePos, mousePos, imgIndex}) => (
        <img {...{
            // a: console.log("mousePos", mousePos),
            src: url,
            ref: imgSize.ref,
            draggable: false,
            style: {
                ...zoomedFrameSize ? {
                    width: zoomedFrameSize.width,
                    ...zoom.value === 1 ? {
                        top : frameRectGross.y + frameRectGross.height/2 - zoomedFrameSize.height/2,
                        left: frameRectGross.x + frameRectGross.width /2 - zoomedFrameSize.width /2,
                    } : {
                        top : mousePos.y - zoomedFramePos.y,
                        left: mousePos.x - zoomedFramePos.x,
                    },
                } : {
                    width: 0,
                },
            },
            // onClick: (e) => e.stopPropagation(),

            "xd-qa-type": "image",
            "xd-qa-name": "Preview enlarged image #" + (imgIndex.value + 1),
        }}/>
    )
);

// const limitPosInRect = (pos, rect) => {
//     if (isPointInRect(pos, rect)) {
//         return pos;
//     }
// };
